import { Component, OnInit, Input, AfterContentInit, AfterViewInit, Output, EventEmitter } from '@angular/core';
// import { CourseService } from 'src/app/services/course.service';
import { ScrollToService, ScrollToConfigOptions } from '@nicky-lenaers/ngx-scroll-to';
import { Router } from '@angular/router';
// import { UtilityService } from 'src/app/services/utility.service';
// import { Store } from 'store';
import { Subscription } from 'rxjs';
// import { Course } from 'src/app/models/course.model';
import { ScoreFaqModalComponent } from '../../score-faq-modal/score-faq-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Course } from 'src/app/shared/models/course.model';
import { User } from 'src/app/shared/models/user.model';
import { CourseService } from 'src/app/shared/services/course.service';
import { UtilityService } from 'src/app/shared/utils/utility.service';
import { Store } from 'src/app/core/store/store';
import { config } from 'src/app/configs/config';
// import { User } from 'src/app/models/user.model';
// import { config } from 'src/app/config';

@Component({
  selector: 'app-exercise-insights',
  templateUrl: './exercise-insights.component.html',
  styleUrls: ['./exercise-insights.component.css']
})
export class ExerciseInsightsComponent implements OnInit, AfterContentInit, AfterViewInit {

  @Output() endScreeen: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Input() courseId: any;
  @Input() courseFeedback: any;
  @Input() courseTitle: any;
  @Input() nextItemId: any;
  @Input() exerciseDetails: any;
  @Input() exerciseId: any;
  @Input() exerciseData: any = null;
  @Input() totalPoints: number;
  @Input() timeSpent: number;
  @Input() totalExPoints: number;
  @Input() evaluationResult: any;
  @Input() exerciseRows: any;
  @Input() fromCoursePage: boolean = false;
  @Input() isMuteScores:boolean;
  isLoaded = false;
  courseSubscription= Subscription.EMPTY;
  course:Course;
  showFeedback:boolean=false;
  enableCustomiseMessaging: boolean = false;
  user: User;
  constructor(private courseService: CourseService, private _scrollService: ScrollToService, public router: Router, private utilityService: UtilityService,private store:Store, private modalService: NgbModal) { }
  ngOnInit() {
    this.courseSubscription = this.store.select<Course>(`course`).subscribe(course => {
      if(course){
        this.course = course;
        console.log(this.course);
       this.showFeedback = !(this.course.hideViewFeedback && this.exerciseData.type=='TOUCHSTONE');
       this.enableCustomiseMessaging = this.course.enableCustomiseMessaging;
      }
    });
    if(!this.exerciseData){
      this.courseService.getExercise(this.exerciseId).subscribe(res => {
        if (res) {
          this.isLoaded = true;
          res.pages.forEach((el, i) => i && res.pages[0].elements.push(...el.elements))
          res.pages.length = 1;
          this.exerciseData = res;
        }
      }, err => {
        this.isLoaded = true;
      });
    }
    else {
      this.isLoaded = true;
    }
    console.log(this.exerciseData);
    console.log(this.evaluationResult);
    this.store.select<User>("user").subscribe(userData => {
      if (userData) { this.user = userData }
    });
  }

  ngAfterContentInit() {
  }

  ngAfterViewInit() {
  }

  scrollToFeedback(id = "") {
    this.utilityService.updateEngagement('EntusiasticAdoption', 'ViewFeedback', 2).subscribe();
    if (this.router.url.includes('player')) {
      const config: ScrollToConfigOptions = { target: "#resultsData", offset: -100 }
      this._scrollService.scrollTo(config);
    }
    else {
      this.navigateToPlayer(this.exerciseId);
    }

  }

  navigateToPlayer(id, type = 'HTML') {
    this.openPlayer(type, id);
  }

  openPlayer(type, id) {
    this.utilityService.setModuleNavigationData(type, id);
    if(this.user && this.user.organization && config.SAME_TAB_OPEN_ORG.includes(this.user.organization)) {
      this.router.navigate([`/player/${this.courseId}`]);
    } else {
      window.open(`/player/${this.courseId}`, '_blank');
    }
  }

  next() {
    if (this.nextItemId)
      this.courseService.setcurrentPlayedItem(this.nextItemId);
    else this.endScreeen.emit(true);
  }

  openScoreFaqModal() {
    const modalRef = this.modalService.open(ScoreFaqModalComponent, {
      windowClass: 'modal-cntrl modal-cntrl-lg'
    });
  }
  
}
